export function registerCounter(Alpine) {
    Alpine.data('counter', ({ target = 0, suffix = '', delay = 0 }) => ({
        current: 0,
        target,
        suffix,
        done: false,

        get display() {
            return this.current + this.suffix;
        },

        start() {
            if (this.done) return;
            this.done = true;

            setTimeout(() => {
                const duration = 1500;
                const start = performance.now();

                const step = (now) => {
                    const elapsed = now - start;
                    const progress = Math.min(elapsed / duration, 1);
                    const eased = progress === 1 ? 1 : 1 - Math.pow(2, -10 * progress);
                    this.current = Math.round(this.target * eased);
                    if (progress < 1) requestAnimationFrame(step);
                };

                requestAnimationFrame(step);
            }, delay);
        },
    }));
}
